import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { StatisticsCountDto } from '@smmof/dto';

export const StatisticsActions = createActionGroup({
  source: 'Statistics',
  events: {
    'Get Statistics': emptyProps(),
    'Get Statistics Success': props<{ statistics: StatisticsCountDto }>(),
    'Get Statistics Failure': props<{ error: any }>(),
  },
});
